import Comment from 'Feedback/component/Comment.vue';
import pagination from 'Site/js/mixin/pagination.input.check';
import store from 'Site/js/store';
import SiteSelect from 'Site/component/SiteSelect.vue';
import Vue from 'vue';

export default function () {
    new Vue({ /* eslint no-new: 0 */
        el: '#page-body',
        name: 'myFeedbackPage',
        store,
        mixins: [pagination],
        data() {
            return {
                commentType: store.state.config.data.commentType,
                mediaType: store.state.config.data.mediaType,
                show: store.state.config.data.show
            };
        },
        components: {
            Comment,
            SiteSelect
        },
        methods: {
            addReply({ reply, parent }) {
                parent.replies.push(reply);
                parent.numReplies += 1;
            }
        }
    });

    const media = [];
    if (store.state.config) {
        store.state.config.data.mediaCollection.forEach((mediaItem) => {
            mediaItem.user = mediaItem.profile;
            media.push(mediaItem);
        });
    }

    const $mediaItems = document.querySelectorAll('.feedback-media .media');
    if ($mediaItems.length) {
        for (let i = 0; i < $mediaItems.length; i++) {
            $mediaItems[i].addEventListener('click', (event) => {
                event.preventDefault();
                store.dispatch('showMediaViewer', {
                    media,
                    id: parseInt(event.currentTarget.getAttribute('data-id'), 10)
                });
            });
        }
    }

}
